import { render, staticRenderFns } from "./ArtisanAppointmentDateSelection.vue?vue&type=template&id=385e76e4&scoped=true"
import script from "./ArtisanAppointmentDateSelection.vue?vue&type=script&lang=ts"
export * from "./ArtisanAppointmentDateSelection.vue?vue&type=script&lang=ts"
import style0 from "./ArtisanAppointmentDateSelection.vue?vue&type=style&index=0&id=385e76e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385e76e4",
  null
  
)

export default component.exports